function AutoFilterFormRangeWoOpLayout ( props ) {

    const { children } = props;

    return (
        <div>
            { children }
        </div>
    );

}

export default AutoFilterFormRangeWoOpLayout;

